module.exports = __webpack_public_path__ + "ClientApp/content/qualityOfLife/cat_belly.svg";